import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const Circle = ({ height = '16px', width = '16px', fill = 'currentColor', }) => {
    return (_jsx(BaseIcon, { width: width, height: height, viewBox: '0 0 16 16', fill: 'none', children: _jsx("circle", { cx: '7.99992', cy: '8', r: '6.66667', fill: fill }) }));
};
//# sourceMappingURL=Circle.js.map